module.exports = __webpack_public_path__ + "img/HD_INCOMING_GOODS_2.432506af.png";